/**
 * Mobile Metro Menu — orchestrator (≤768px tile navigation).
 * Data: navigation/mobilemetro/mobileMetroMenuData
 * Controller: navigation/mobilemetro/useMobileMetroMenuController
 * Levels: MobileMetroLevel1/2/3
 */

import React from 'react';
import useMobileMetroMenuController from './navigation/mobilemetro/useMobileMetroMenuController';
import MobileMetroLevel1 from './navigation/mobilemetro/MobileMetroLevel1';
import MobileMetroLevel2 from './navigation/mobilemetro/MobileMetroLevel2';
import MobileMetroLevel3 from './navigation/mobilemetro/MobileMetroLevel3';
import './MobileMetroMenu.css';

const MobileMetroMenu = ({ isOpen, onClose }) => {
  const ctrl = useMobileMetroMenuController({ isOpen, onClose });

  if (!isOpen) return null;

  const isInlineMode = !onClose;

  return (
    <div className="mobile-metro-menu">
      {!isInlineMode && (
        <div className="mobile-metro-overlay" onClick={ctrl.handleClose} />
      )}
      <div className="mobile-metro-content" data-tour="mobile-metro">
        {ctrl.level === 1 && (
          <MobileMetroLevel1
            getMainMenus={ctrl.getMainMenus}
            hasMenuAccess={ctrl.hasMenuAccess}
            handleSyncOfflinePack={ctrl.handleSyncOfflinePack}
            syncingOfflinePack={ctrl.syncingOfflinePack}
            online={ctrl.online}
            activeProject={ctrl.activeProject}
            offlineSyncNote={ctrl.offlineSyncNote}
            myOpenPettyFunds={ctrl.myOpenPettyFunds}
            menusLoaded={ctrl.menusLoaded}
            handleNavigate={ctrl.handleNavigate}
            showProjectPicker={ctrl.showProjectPicker}
            setShowProjectPicker={ctrl.setShowProjectPicker}
            configuredProjects={ctrl.configuredProjects}
            handleQuickActivateProject={ctrl.handleQuickActivateProject}
            hasUnreadOpsChat={ctrl.hasUnreadOpsChat}
            handleLevel1Click={ctrl.handleLevel1Click}
            hasProjects={ctrl.hasProjects}
          />
        )}
        {ctrl.level === 2 && (
          <MobileMetroLevel2
            level1Selection={ctrl.level1Selection}
            getMainMenus={ctrl.getMainMenus}
            getSubSections={ctrl.getSubSections}
            handleBack={ctrl.handleBack}
            handleLevel2Click={ctrl.handleLevel2Click}
          />
        )}
        {ctrl.level === 3 && (
          <MobileMetroLevel3
            level1Selection={ctrl.level1Selection}
            level2Selection={ctrl.level2Selection}
            getMainMenus={ctrl.getMainMenus}
            getSubSections={ctrl.getSubSections}
            getMenuItems={ctrl.getMenuItems}
            isDemoProjectBootstrap={ctrl.isDemoProjectBootstrap}
            hasMenuAccess={ctrl.hasMenuAccess}
            online={ctrl.online}
            hasUnreadOpsChat={ctrl.hasUnreadOpsChat}
            setLevel={ctrl.setLevel}
            handleBack={ctrl.handleBack}
            handleMenuItemClick={ctrl.handleMenuItemClick}
          />
        )}
      </div>
    </div>
  );
};

export default MobileMetroMenu;
